import React, { useEffect, useMemo, useState } from "react";
import AddParticipantReviewCG from "./AddParticipantReviewCG";
import SearchBox from "../../../components/Search/SearchBox";
import Icon from "../../../components/Icons/Icon";
import useSearchData from "../../../components/useSearchData";
import FormikController from "../../../components/FormikController/FormikController";
import { createColumnDef, useOnGridReady } from "../../../Utils/AgGridUtils";
import ClientStore from "../../../Store/ClientStore";
import { centerStyles, leftStyles } from "../../../Constants/Constants";
import { useParams } from "react-router-dom";
import AgencyStore from "../../../Store/AgencyStore";

const ParticipantReviewAndCareGiverViewPage = () => {
  const { clientId } = useParams();
  const [onGridReady] = useOnGridReady(ClientStore, "safetyAgGrid");
  const [show, setShow] = useState(false);
  const [editData, setEditData] = useState([]);
  const [openEditButton, setOpenEditButton] = useState("save");
  const [reviewCg, setReviewCg] = useState(
    ClientStore?.individualParticipationInfoList
  );
  const handleOpen = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setOpenEditButton("save");
  };
  const [handleSearchChange] = useSearchData();
  const columnDefs = useMemo(
    () => [
      createColumnDef("clientName", "Client Name", leftStyles, "", "", 90),
      createColumnDef("rnName", "Nurse Name", leftStyles, "", "", 90),
      createColumnDef("caregiverName", "Nurse Name", leftStyles, "", "", 90),
      createColumnDef(
        "caregiverName",
        "CareGiver Name",
        leftStyles,
        "",
        "",
        90
      ),

      createColumnDef("visitType", "Visit Type", leftStyles, "", "", 70),
      createColumnDef("systemEntryDate", "Upload Date", leftStyles, "", "", 80),
      createColumnDef(
        "lastUpdatedDate",
        "Modified Date",
        leftStyles,
        "",
        "",
        80
      ),

      {
        headerName: "Action",
        sortable: false,
        headerClass: "center-header",
        cellStyle: (params) => {
          return centerStyles;
        },
        width: 100,
        cellRenderer: (params) => {
          const handleEditButton = () => {
            setEditData(params.data);
            setOpenEditButton("update");
            handleOpen();
          };
          const handleDownloadButton = () => {
            // setEditData(params.data);
            // openPdf(<CGPOSPdf dataList={params.data} />);
          };
          return (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <div className="manageClick" onClick={() => handleEditButton()}>
                Edit
              </div>
              {/* <div
                  className="docViewText"
                  onClick={() => handleDownloadButton()}
                >
                  View
                </div> */}
            </div>
          );
        },
      },
    ],
    []
  );
  useEffect(() => {
    if (AgencyStore.isSaveLoading) {
      const fetchData = async () => {
        await ClientStore.getParticipantReviewList(clientId);
        setReviewCg(ClientStore?.individualParticipationInfoList);
        AgencyStore.setIsSaveLoading(false);
      };
      fetchData();
    }
  }, [AgencyStore.isSaveLoading]);

  return (
    <>
      <div className="homeSafetyWrapper">
        {show ? (
          <AddParticipantReviewCG
            type={openEditButton}
            editData={editData}
            handleClose={handleClose}
            handleOpen={handleOpen}
          />
        ) : (
          <>
            <div className="actionButtonSearchMainContainer">
              <div className="searchMainCotainer">
                <div className="searchContainer">
                  <SearchBox
                    handleChange={(e) => {
                      handleSearchChange(e, "DocList");
                    }}
                  />
                </div>
                <div className="underlineClick" onClick={handleOpen}>
                  <Icon iconName="circleAdd" />
                  Add Participation Review And CG Supervisory Visit
                </div>
              </div>
            </div>
            <FormikController
              rowData={reviewCg}
              control="agGrid"
              columnDefs={columnDefs}
              onGridReady={onGridReady}
            />
          </>
        )}
      </div>
    </>
  );
};

export default ParticipantReviewAndCareGiverViewPage;
